export default __webpack_public_path__ + "static/media/menu1.d252eb1e.png";